import React from 'react';
import { Card, CardHeader, CardContent } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';


const cellStyle = {
  padding: '6px 16px 6px 12px'
}

const SamantektAdstodTable = (props) => {
  const { talning, embaetti } = props;

  if (talning.heildarfjoldi === undefined) {
    return (
      <Card>
        <CardHeader title={"Samantekt atkvæða"} subheader={embaetti} />
        <Divider />
        <CardContent>
          <Typography>Engin gögn fundust</Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader title={"Samantekt atkvæða - Aðstoð"} subheader={embaetti} />
      <Divider />
      <CardContent>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell style={cellStyle}>Aðstoð veitt af</TableCell>
              <TableCell style={cellStyle}>Alls</TableCell>
              <TableCell style={cellStyle}>Karlar</TableCell>
              <TableCell style={cellStyle}>Konur</TableCell>
              <TableCell style={cellStyle}>Kynsegin</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow hover>
              <TableCell style={cellStyle}>Kjörstjóra</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodKjorstjori.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodKjorstjori.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodKjorstjori.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodKjorstjori.kynsegin}</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell style={cellStyle}>Aðstoðarmanni kjósanda</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodFulltrui.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodFulltrui.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodFulltrui.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodFulltrui.kynsegin}</TableCell>
            </TableRow>
            {/* <TableRow hover>
              <TableCell style={cellStyle}>Aðstoð vegna sjónleysis</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodBlindur.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodBlindur.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodBlindur.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodBlindur.kynsegin}</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell style={cellStyle}>Aðstoð vegna ónothæfrar handar</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodHond.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodHond.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodHond.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodHond.kynsegin}</TableCell>
            </TableRow>
            <TableRow hover>
              <TableCell style={cellStyle}>Aðstoð frá fulltrúa og staðfest með vottorði réttindagæslumanns</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodFulltruiVottord.alls}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodFulltruiVottord.karlar}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodFulltruiVottord.konur}</TableCell>
              <TableCell style={cellStyle}>{talning.fjoldiAdstodFulltruiVottord.kynsegin}</TableCell>
            </TableRow> */}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export default SamantektAdstodTable;